import state from './state'

const initialState = JSON.parse(JSON.stringify(state))

export const SET_TASKS = (state, tasks) => {
  state.tasks = tasks
}

export const RESET = (state) => {
  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key]
  })
}
